"use strict";

define('model/user.setting',['./setting'], function (Setting) {
  var UserSetting = Setting.extend({
    idAttribute: 'id',
    urlRoot: '/rs/api/setting',
    sync: function sync(method, model, options) {
      options = options || {};
      if (method == 'update') {
        options.method = 'POST';
      }
      return Setting.prototype.sync.apply(this, arguments);
    }
  }, {
    all: function all(product) {
      return this.createCollection('/rs/api/setting/product/:product').params({
        product: product
      });
    }
  });
  return UserSetting;
});

